import * as React from "react"

// Promotions
import CsecPromotion from "./csecPromotion"
import FindProgram from "./findProgram"

import Slider from "react-slick"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"
import { isMobile } from "react-device-detect"

const settings = {
  dots: true,
  infinite: true,
  speed: 250,
  slidesToShow: 1,
  slidesToScroll: 1
}

function CoursePromotion(props) {
  return (
    <Slider {...settings} style={{ width: "100%" }}>
      <CsecPromotion countryCode={props.countryCode} />
      <FindProgram countryCode={props.countryCode} />{" "}
    </Slider>
  )
}

export default CoursePromotion
